import React from "react";
import styled from "@emotion/styled";
import { theme } from "@/theme";

type ProductBadgeProps = {
  text: string;
  size?: "default" | "lg";
};

const Badge = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: hsl(var(--color-primary));

  p {
    text-align: center;
    color: hsl(var(--color-white));
    margin: 0;
    padding: ${theme.spacing(1)} ${theme.spacing(2)};
    font-size: 14px;
    font-weight: 600;
    line-height: 130%;
  }

  &.lg {
    p {
      font-size: 16px;
    }
  }

  ${theme.breakpoints.down("md")} {
    p {
      font-size: 12px;
    }
    &.lg {
      p {
        font-size: 14px;
      }
    }
  }
`;

export const ProductBadge = ({ text, size = "default" }: ProductBadgeProps) => {
  return (
    <Badge className={size}>
      <p>{text}</p>
    </Badge>
  );
};
